import { createContainer } from 'react-sweet-state';

import { MainStore, PRIVATE_ACTIONS } from './MainStore';

export const MainStoreContainer = createContainer(MainStore, {
  onInit:
    () =>
    ({ setState, dispatch }, { state }) => {
      dispatch(PRIVATE_ACTIONS.init());

      if (state) {
        setState(state);
      }
    },
  onUpdate:
    () =>
    ({ setState, dispatch }, { state }) => {
      dispatch(PRIVATE_ACTIONS.update());

      if (state) {
        setState(state);
      }
    },
});
